import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function TextContent(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    useTelemetry('TextContent');
    var baseProps = getBaseProps(props);
    var className = clsx(baseProps.className, styles['text-content']);
    return (React.createElement("div", __assign({}, baseProps, { className: className }), children));
}
//# sourceMappingURL=index.js.map